<template>
  <section class="container-fluid my-4">
    <h4 class="my-4">Cadastro de <strong>Candidato</strong></h4>

    <form @submit.prevent="handlerSubmit">
      <div class="row">
        <div class="form-group col-md-6">
          <label for="name">Nome</label>
          <input type="text" class="form-control" id="name" v-model="item.name" />
        </div>
        <div class="form-group col-md-6">
          <label for="phone">Telefone</label>
          <TheMask
            type="text"
            class="form-control"
            id="phone"
            :mask="['(##)#####-####']"
            v-model="item.phone"
            :masked="true"
          />
        </div>
      </div>

      <div class="row">
        <div class="form-group col-md-4">
          <label for="city">Cidade</label>
          <input
            type="text"
            class="form-control"
            id="city"
            placeholder="Recife"
            v-model="item.city"
          />
        </div>
        <div class="form-group col-md-2">
          <label for="state">UF</label>
          <select id="state" class="form-control" v-model="item.state">
            <option :value="null" disabled>-- UF --</option>
            <option v-for="uf in brazilianStates" :key="uf.id" :value="uf.id">
              {{ uf.name }}
            </option>
          </select>
        </div>
        <div class="form-group col-md-3">
          <label for="course_id">Curso</label>
          <select id="course_id" class="form-control" v-model="item.course_id">
            <option disabled value="">-- Selecione --</option>
            <option v-for="course in courses" :key="course.id" :value="course.id">
              {{ course.name }}
            </option>
          </select>
        </div>
        <div class="form-group col-md-3">
          <label for="status">Status</label>
          <select id="status" class="form-control" v-model="item.status">
            <option v-for="option in candidateStatusOptions" :key="option.id" :value="option.id">
              {{ option.name }}
            </option>
          </select>
        </div>
      </div>

      <div class="row">
        <div class="form-group col-md-6">
          <label for="branch_id">Filial</label>
          <select id="branch_id" class="form-control" v-model="item.branch_id">
            <option value="">-- Selecione --</option>
            <option v-for="branch in branches" :key="branch.id" :value="branch.id">
              {{ branch.name }}
            </option>
          </select>
        </div>
      </div>

      <CandidateClosingFields :item="item" />

      <div class="form-group text-center my-2">
        <button type="submit" class="btn btn-success btn-sm mx-2">SALVAR</button>
        <button type="reset" class="btn btn-secondary btn-sm" @click="reset">LIMPAR</button>
      </div>
    </form>
    <button class="btn btn-sm btn-secondary" @click="$router.go(-1)">VOLTAR</button>
  </section>
</template>

<script>
import api from "@/services";
import { errorsToString, candidateStatusOptions, brazilianStates } from "@/helpers";
import CandidateClosingFields from "./CandidateClosingFields.vue";

const emptyItem = () => ({
  name: "",
  phone: "",
  city: "",
  state: null,
  course_id: "",
  branch_id: "",
  status: "Candidato",
  proposal_date: null,
  proposal_value: null,
  closing_type: null,
  closing_date: null,
  closing_value: null,
  payment_type_id: null,
  card_holder: null,
  card_last_digits: null,
  amount_paid: null,
  bank: null,
  paid_off: false,
  service_sent: false,
  service_date: null,
});

export default {
  name: "CandidateRegister",
  components: {
    CandidateClosingFields,
  },
  data() {
    return {
      candidateStatusOptions,
      brazilianStates,
      courses: [],
      branches: [],
      item: emptyItem(),
    };
  },
  methods: {
    reset() {
      this.item = emptyItem();
    },
    async getBranches() {
      const { data } = await api.get("/branches?perPage=99999");
      this.branches = data.data;
    },
    async getCourses() {
      const { data } = await api.get("/courses?page=1&perPage=99999");
      this.courses = data.data;
    },
    async handlerSubmit() {
      try {
        const { data } = await api.post("/candidates", this.item);
        Toast.fire(data.message, "", "success");
        this.$router.push({ name: "candidates" });
      } catch (error) {
        const errors = error.response && error.response.data && error.response.data.errors;
        Toast.fire(errors ? errorsToString(errors) : "Não foi possível salvar o candidato.", "", "error");
      }
    },
  },
  mounted() {
    this.getCourses();
    this.getBranches();
  },
};
</script>
